module.exports = __webpack_public_path__ + "img/hero-dot.a15b08fc.png";